export default __webpack_public_path__ + "static/media/hourglass.af39c345.svg";